<div class="processWrapper">
    <div class="headerline" fxLayout="row">
        <p *ngIf="dataService.ProcessToEdit; else elseBlock" class="pageHeader" >Prozess</p>
        <ng-template #elseBlock ><p class="pageHeader">Neuer Prozess</p></ng-template>
    </div>
    <hr>
    <mat-tab-group class="tabgroup" #tabRef [selectedIndex]="index">
        <mat-tab label="Prozesstyp" [disabled]="index !== 0">
            <div fxLayout="row" fxFlexAlign="stretch" class="mainLine">
                <div fxLayout="row" fxFlexAlign="stretch">
                    <p class="viewHeader">Prozesstyp</p>
                    <button class="navigateButton" *ngIf="typChosen" (click)="confirmProcessType()"
                            mat-raised-button>
                        Weiter
                    </button>
                </div>
                <button fxFlexAlign="end" class="navigateButton" (click)="cancelProcess()" mat-raised-button>
                    Abbrechen
                </button>
            </div>
            <hr>
            <div fxLayout="row" class="EntryRow">
                <p class="conHeader">Prozesstyp wählen</p>
                <mat-form-field class="conTxt">
                    <mat-select [(ngModel)]="typChosen" class="select" (ngModelChange)="onChoiceProcessType($event)">
                        <mat-option *ngFor="let processTyp of processTypToSelect" [value]="processTyp">{{processTyp}} </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </mat-tab>
        <mat-tab label="Inputartikel" [disabled]="index !== 1">
            <div fxLayout="row" fxFlexAlign="stretch" class="mainLine">
                <div fxLayout="row" fxFlexAlign="stretch">
                    <p class="viewHeader">Inputartikel Auswahl</p>
                    <button class="navigateButton" mat-raised-button (click)="goBackToProcessTypeChoice()">Zurück</button>
                    <button class="navigateButton" *ngIf="selectedInputProduct" (click)="confirmInputProduct()"
                            mat-raised-button>
                        Weiter
                    </button>


                </div>
                <button fxFlexAlign="end" class="navigateButton" (click)="cancelProcess()" mat-raised-button>
                    Abbrechen
                </button>
            </div>
            <hr>
            <div class="tabFlex">
                <div class="leftTable" fxLayout="column" fxFlexAlign="stretch">
                    <mat-form-field>
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput type="search" placeholder="suchen" class="search-input"
                               [(ngModel)]="SearchStringProduct">
                    </mat-form-field>
                    <p *ngIf="!showAllInput"><strong>Top 10 Artikel:</strong></p>
                    <p *ngIf="showAllInput"><strong>Alle Artikel:</strong></p>
                    <cdk-virtual-scroll-viewport itemSize="50" class="viewportProducts" *ngIf="inputproducts">
                        <table class="productTable2">
                            <tr>
                                <th style="width: 20%">Nummer</th>
                                <th style="width: 80%">Name</th>
                            </tr>
                            <tr *ngFor="let product of inputproducts | ArtikelFilter:SearchStringProduct"
                                (click)="selectInputProduct(product)"
                                [ngClass]="{'selectedone': selectedInputProduct === product}">
                                <td>{{product.id}}</td>
                                <td>{{product.name}}</td>
                            </tr>
                        </table>
                    </cdk-virtual-scroll-viewport>



                    <button class="showButton" *ngIf="!showAllInput" (click)="showAllInputProducts()" mat-raised-button>
                        Alle anzeigen
                    </button>

                    <button class="showButton" *ngIf="showAllInput" (click)="showAllInputProducts()" mat-raised-button>
                        Top 10 anzeigen
                    </button>
                </div>
                <div class="rightTable">
                    <div *ngIf="selectedInputProduct">
                        <h1 class="tableheader">Ausgewählt
                        </h1>
                        <p> Nummer: {{selectedInputProduct.id}}</p>
                        <p>Name: {{selectedInputProduct.name}} </p>

                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Ressourcentyp" [disabled]="index !== 2">
            <div fxLayout="row" fxFlexAlign="stretch" class="mainLine">
                <div fxLayout="row" fxFlexAlign="stretch">
                    <p class="viewHeader">Ressourcentyp</p>
                    <button class="navigateButton" mat-raised-button (click)="goBackToInputProduct()">Zurück</button>
                    <button class="navigateButton" (click)="confirmRessources()"
                            *ngIf="ready && selectedRessources.length>0 && !checkValidity() || typChosen == 'Instandhaltung'" mat-raised-button>
                        Weiter
                    </button>


                </div>
                <button fxFlexAlign="end" class="navigateButton" (click)="cancelProcess()" mat-raised-button>
                    Abbrechen
                </button>
            </div>
            <hr>

            <div class="tabFlex2" *ngIf="machines && workers">
                <div class="leftTable" fxLayout="column" fxFlexAlign="stretch">
                    <h2>Maschinen</h2>
                    <mat-form-field>
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput type="search" placeholder="suchen" class="search-input" [(ngModel)]="searchString5">
                    </mat-form-field>
                    <div fxLayout="column" class="workerList">
                        <div class="listHeader" fxLayout="column" fxFlexAlign="stretch">
                            <p class="listHeaderP" fxFlexAlign="center">NAME</p>
                        </div>
                        <cdk-virtual-scroll-viewport itemSize="50" class="viewportRessource" *ngIf="machines.length>0">
                            <div class="machineelement"
                                 *ngFor="let machine of getMachineRessourceToShow() | ResourceTypeFilter:searchString5"
                                 fxLayout="column" (click)="chooseResource(machine)">
                                <p class="machineEntry">{{machine.name}}</p>
                            </div>
                        </cdk-virtual-scroll-viewport>
                        <div class="paginator"
                             [ngClass]="{'paginatorBoth': skipMachine && showNextMachine,  'paginatorRight': !skipMachine}">
                            <div class="previous" (click)="paginateLeftMachine()" *ngIf="skipMachine">
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </div>
                            <div class="next" (click)="paginateRightMachine()" *ngIf="showNextMachine">
                                <mat-icon>keyboard_arrow_right</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="midTable" *ngIf="workers" fxLayout="column" fxFlexAlign="stretch">
                    <h2>Mitarbeiter</h2>
                    <mat-form-field>
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput type="search" placeholder="suchen" class="search-input" [(ngModel)]="searchString4">
                    </mat-form-field>

                    <div fxLayout="column" class="workerList">
                        <div class="listHeader" fxLayout="column" fxFlexAlign="stretch">
                            <p class="listHeaderP" fxFlexAlign="center">NAME</p>
                        </div>
                        <cdk-virtual-scroll-viewport itemSize="50" class="viewportRessource" *ngIf="workers.length>0">
                            <div class="workerelement"
                                 *ngFor="let worker of getWorkerRessourceToShow() | ResourceTypeFilter:searchString4"
                                 fxLayout="column" (click)="chooseResource(worker)">
                                <p class="workerEntry">{{worker.name}}</p>
                            </div>
                        </cdk-virtual-scroll-viewport>
                        <div class="paginator"
                             [ngClass]="{'paginatorBoth': skipWorker && showNextWorker,  'paginatorRight': !skipWorker}">
                            <div class="previous" (click)="paginateLeftWorker()" *ngIf="skipWorker">
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </div>
                            <div class="next" (click)="paginateRightWorker()" *ngIf="showNextWorker">
                                <mat-icon>keyboard_arrow_right</mat-icon>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="rightTable2" fxLayout="column" fxFlexAlign="stretch">
                    <h1 class="tableheader">Ausgewählt

                    </h1>

                    <div fxLayout="column" class="workerList">
                        <div class="listHeaderSelected" fxLayout="row" fxFlexAlign="stretch">
                            <p class="listHeaderPType" fxFlexAlign="center">Type</p>
                            <p class="listHeaderPName" fxFlexAlign="center">NAME</p>
                            <p class="listHeaderPQuant" fxFlexAlign="center">MENGE</p>
                        </div>


                        <cdk-virtual-scroll-viewport itemSize="50" class="viewportSelected" *ngIf="selectedRessources">
                            <div class="workerSelEntry" [ngClass]="{'machineSelEntry': ressource.type === 'machine'}"
                                 *ngFor="let ressource of selectedRessources" fxLayout="row">
                                <svg class="resorceSVG" *ngIf="ressource.group === 'machine'"
                                     xmlns="http://www.w3.org/2000/svg" height="50px" width="50px" viewBox="0 0 32 32"
                                     (click)="chooseResourceBack(ressource)">
                                    <g>
                                        <path id="path1"
                                              transform="rotate(0,16,16) translate(8,8.00000190734818) scale(0.499999880790739,0.499999880790739)  "
                                              fill="black"
                                              d="M23.004997,23L26.004997,23 26.004997,26 23.004997,26z M17.039,23L20.039,23 20.039,26 17.039,26z M10.930971,23L13.930971,23 13.930971,26 10.930971,26z M5.000001,23L8.0000019,23 8.0000019,26 5.000001,26z M21.999954,12.767011L21.999954,14.000005 21.99894,14.02016 21.99906,14.043963 21.996159,14.075382 21.994799,14.102366 21.99192,14.121269 21.990135,14.140604 21.9846,14.169344 21.979668,14.201744 21.974434,14.222138 21.971626,14.236718 21.964888,14.259338 21.955059,14.297638 21.946501,14.321055 21.943356,14.331615 21.936909,14.347305 21.921471,14.38955 21.908327,14.416871 21.905148,14.424608 21.899704,14.434791 21.879406,14.476979 21.86054,14.508061 21.856827,14.515009 21.851551,14.522873 21.829363,14.559426 21.806456,14.590077 21.799837,14.599939 21.792114,14.609263 21.771839,14.636391 21.747101,14.663615 21.735821,14.677237 21.725134,14.68779 21.707336,14.707376 21.681841,14.730545 21.665461,14.746721 21.652527,14.757184 21.636353,14.77188 21.610086,14.791514 21.589443,14.808211 21.575209,14.817582 21.559389,14.829405 21.531897,14.846093 21.508451,14.861528 21.493382,14.869472 21.476944,14.87945 21.448469,14.893151 21.423168,14.90649 21.406828,14.913187 21.389517,14.921516 21.361694,14.931683 21.33428,14.942919 21.315144,14.948694 21.297607,14.955103 21.272947,14.961432 21.242468,14.970632 21.218092,14.97551 21.201715,14.979713 21.18236,14.982661 21.148418,14.989452 21.116171,14.992739 21.102341,14.994845 21.08884,14.995525 21.052814,14.999197 21.011791,14.999405 20.999981,15 20.990334,14.999514 20.956341,14.999686 20.911661,14.995552 20.897621,14.994845 20.887709,14.993335 20.859682,14.990741 20.818588,14.98281 20.798246,14.979713 20.785223,14.976371 20.763519,14.972182 20.730566,14.962344 20.702354,14.955103 20.684679,14.948644 20.668541,14.943826 20.645185,14.934212 20.610443,14.921516 20.587332,14.910395 20.575426,14.905494 20.560175,14.89733 20.523016,14.87945 20.494873,14.862367 20.484863,14.857008 16.999954,12.767016 16.999954,16.000004C16.999954,16.553002,16.552965,17,15.999981,17L15.960991,16.998036 15.921997,17 2,17 2,30 30,30 30,18 30.000006,14.566013 27.000006,12.767018 27.000006,14.000015 26.998943,14.021098 26.99906,14.043957 26.996273,14.074129 26.99485,14.102376 26.991838,14.122161 26.990135,14.140598 26.984858,14.168006 26.979719,14.201754 26.974268,14.222994 26.971626,14.236711 26.965284,14.257998 26.955109,14.297649 26.946253,14.321887 26.943356,14.331609 26.93742,14.346058 26.921522,14.38956 26.90799,14.417685 26.905148,14.424602 26.90028,14.433709 26.879456,14.476989 26.860107,14.508865 26.856827,14.515002 26.853273,14.520126 26.829411,14.559437 26.781811,14.623124 26.780218,14.62542 26.779539,14.626164 26.771887,14.636403C26.75152,14.661089,26.72999,14.684778,26.707382,14.707388L26.695768,14.71794 26.69169,14.722408 26.680408,14.731899 26.636396,14.771892 26.604696,14.795584 26.592829,14.805567 26.582415,14.812238 26.559431,14.829416 26.486227,14.87385 26.485212,14.8745 26.476982,14.879461C26.448643,14.894841,26.419472,14.908891,26.389553,14.921528L26.373125,14.927531 26.370424,14.928809 26.362982,14.931237 26.297642,14.955115 26.261007,14.964516 26.250046,14.968094 26.238249,14.970357 26.201746,14.979725 26.142008,14.988821 26.125662,14.991957 26.118378,14.992419 26.102367,14.994857C26.068716,14.998266,26.034569,15.000012,26.000006,15.000012L25.999256,14.999974 25.99885,15 25.995924,14.999806 25.897644,14.994857 25.879576,14.992105 25.867353,14.991297 25.846233,14.987028 25.798265,14.979725 25.754461,14.968483 25.736607,14.964875 25.725967,14.96117 25.702372,14.955115C25.639713,14.935661,25.57971,14.910221,25.523029,14.879461L25.492275,14.860794 25.484863,14.857001z M2.9305747,2L2.001688,15 6.9973249,15 6.0684385,2z M1.0686553,0L7.9303579,0 8.9963121,14.929 8.9978724,15 15.000007,15 15.000007,9.2330289 20.000006,12.233863 20.000006,9.2330289 25.000006,12.23386 25.000006,9.2330289 32.000008,13.434017 32.000008,18.000003 32,32 0,32 0,15 0.0011410716,15 0.0027012832,14.929z"/>
                                    </g>
                                </svg>
                                <svg class="resorceSVG" *ngIf="ressource.group === 'human'"
                                     xmlns="http://www.w3.org/2000/svg" height="50px" width="50px" viewBox="0 0 32 32"
                                     (click)="chooseResourceBack(ressource)">
                                    <g>
                                        <path id="path1"
                                              transform="rotate(0,16,16) translate(9.77499961853027,8) scale(0.5,0.5)  "
                                              fill="black"
                                              d="M19.69999,25.699982C18.799997,25.699982 18.099984,26.399994 18.099984,27.299988 18.099984,28.199982 18.799997,28.899994 19.69999,28.899994 20.599982,28.899994 21.299995,28.199982 21.299995,27.299988 21.299995,26.399994 20.599982,25.699982 19.69999,25.699982z M19.19999,22.5L20.199989,22.5 20.199989,23.599976C20.500007,23.599976,20.799995,23.699982,21.099982,23.799988L21.599982,22.899994 22.400001,23.399994 22.000007,24.299988C22.299995,24.5,22.500007,24.699982,22.699989,25L23.599982,24.5 24.099982,25.299988 23.199989,25.799988C23.299995,26.099976,23.400001,26.399994,23.400001,26.699982L24.500007,26.699982 24.500007,27.699982 23.400001,27.699982C23.400001,28,23.299995,28.299988,23.199989,28.599976L24.099982,29.099976 23.599982,29.899994 22.699989,29.399994C22.500007,29.699982,22.299995,29.899994,22.000007,30.099976L22.500007,31 21.699989,31.5 21.199989,30.599976C20.900001,30.699982,20.599982,30.799988,20.299995,30.799988L20.299995,32 19.299997,32 19.299997,30.899994C19.000009,30.899994,18.69999,30.799988,18.400003,30.699982L17.900003,31.599976 17.1,31.099976 17.599984,30.199982C17.299997,30,17.1,29.799988,16.900003,29.5L15.999994,30 15.499994,29.199982 16.400003,28.699982C16.299997,28.399994,16.19999,28.099976,16.19999,27.799988L14.999994,27.799988 14.999994,26.799988 16.1,26.799988C16.1,26.5,16.19999,26.199982,16.299997,25.899994L15.400004,25.399994 15.900004,24.599976 16.799997,25.099976C16.999994,24.799988,17.19999,24.599976,17.500009,24.399994L16.999994,23.5 17.799997,23 18.299997,23.899994C18.599984,23.799988,18.900003,23.699982,19.19999,23.699982z M6.6999943,18.199982C8.2999995,19.399994 10.299999,20.099976 12.499995,20.099976 14.699991,20.099976 16.69999,19.399994 18.299997,18.199982 21.799995,18.599976 24.599982,21.5 24.900001,25.099976L24.900001,25.199982C24.099982,23.199982 22.099982,21.799988 19.799997,21.799988 16.69999,21.799988 14.199991,24.299988 14.199991,27.399994 14.199991,28 14.299998,28.5 14.499994,29.099976L14.600001,29.299988 0,29.299988 0,26C-2.2138283E-07,21.899994,2.9000079,18.699982,6.6999943,18.199982z M5.6000039,8.5999756L11.699992,8.5999756 13.699991,8.5999756 14.699991,8.5999756 19.19999,8.5999756 19.19999,8.7999878C19.299997,9.3999939 19.400003,9.8999939 19.400003,10.5 19.400003,14.399994 16.299997,17.5 12.400005,17.5 8.4999964,17.5 5.400007,14.399994 5.400007,10.5 5.400007,9.8999939 5.4999978,9.2999878 5.6000039,8.7999878z M15.600001,0.79998779C17.799997,1.8999939 19.299997,4.1999817 19.299997,6.7999878 19.299997,7.1999817 19.299997,7.5 19.19999,7.7999878L14.400004,7.7999878C14.199991,6,14.199991,1.5,15.600001,0.79998779z M9.4999964,0.69998169C11.100002,1,11.100002,5.8999939,10.999995,7.7999878L5.6999948,7.7999878C5.6000039,7.5 5.6000039,7.0999756 5.6000039,6.7999878 5.6999948,4.0999756 7.1999943,1.7999878 9.4999964,0.69998169z M12.499995,0C13.400005,0 14.299998,0.19998169 15.100001,0.5 13.600001,1.8999939 13.799998,6.6999817 13.900004,7.7999878L11.499995,7.7999878C11.600002,6.6999817 11.900005,1.5999756 10.199993,0.3999939 10.900005,0.099975586 11.600002,0 12.499995,0z"/>
                                    </g>
                                </svg>

                                <p class="ressourceName">{{ressource.name}}</p>

                                <mat-form-field [ngClass]="{'error': ressource.notvalid}">
                                    <input #quan="ngModel" (newItemEvent)="validityChecked($event, ressource)" name="quan"
                                           appStepValidator id="{{ressource.id}}" stepSize="{{ressource.step_size}}"
                                           defaultQuantity="{{ressource.default_quantity}}" class="ressourceQuantity"
                                           pattern="^\d*(\.\d{0,2})?$" (keyup)="onKeydown($event, ressource)" matInput
                                           [(ngModel)]="ressource.quantity" type="number" value="{{ressource.quantity}}"
                                           step="{{ressource.step_size}}" min="{{ressource.default_quantity}}">
                                    <div *ngIf="quan.hasError('gte')" class="errorMessage">
                                        *Wert ungültig (Schrittweite ist {{ressource.step_size}}).
                                        Möglicher Wert bspw: {{ressource.suggestedValue}}
                                    </div>
                                    <div *ngIf="quan.hasError('nullError')" class="errorMessage">
                                        Menge darf nicht Null sein.
                                    </div>
                                    <div *ngIf="quan.errors?.pattern && !quan.hasError('negativeError')"
                                         class="errorMessage">
                                        Menge darf nicht mehr als 2 Zahlen nach Komma haben.
                                    </div>


                                </mat-form-field>


                                <svg xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 32 32"
                                     class="removeSVG" (click)="chooseResourceBack(ressource)">
                                    <g>
                                        <ellipse cy="16" cx="16" ry="16" rx="16"/>
                                        <path id="path1" transform="rotate(0,16,16) translate(1.6,1.6) scale(0.9,0.9)  "
                                              fill="white"
                                              d="M20.200012,8.4000015L16,12.599998 11.800049,8.5 8.4000244,11.900002 12.600037,16.099998 8.4000244,20.300003 11.800049,23.699997 16,19.5 20.200012,23.699997 23.600037,20.300003 19.400024,16 23.600037,11.800003z M16,0C24.800049,0 32,7.1999969 32,16 32,24.800003 24.800049,32 16,32 7.2000122,32 0,24.800003 0,16 0,7.1999969 7.2000122,0 16,0z"/>
                                    </g>
                                </svg>

                            </div>
                        </cdk-virtual-scroll-viewport>
                    </div>
                </div>
            </div>


        </mat-tab>
        <mat-tab label="Outputartikel" [disabled]="index !== 3">
            <div fxLayout="row" fxFlexAlign="stretch" class="mainLine">
                <div fxLayout="row" fxFlexAlign="stretch">
                    <p class="viewHeader">Outputartikel Auswahl</p>
                    <button class="navigateButton" mat-raised-button (click)="go(-1)">Zurück</button>
                    <ng-container *ngIf="selectedOutputProducts">
                        <button class="navigateButton" (click)="confirmOutputProducts()"
                                *ngIf="selectedOutputProducts.length!=0;" mat-raised-button>
                            Weiter
                        </button>
                    </ng-container>

                </div>
                <button fxFlexAlign="end" class="navigateButton" (click)="cancelProcess()" mat-raised-button>
                    Abbrechen
                </button>
            </div>
            <hr>
            <div class="tabFlex2">
                <div class="leftTable" fxLayout="column" fxFlexAlign="stretch">
                    <mat-form-field>
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput type="search" placeholder="suchen" class="search-input"
                               [(ngModel)]="SearchStringOutProduct">
                    </mat-form-field>

                    <p *ngIf="!showAllOutput"><strong>Top 10 Artikel:</strong></p>
                    <p *ngIf="showAllOutput"><strong>Alle Artikel:</strong></p>
                    <cdk-virtual-scroll-viewport itemSize="10" class="viewportProducts" *ngIf="outputProducts">
                        <table class="outputProductTable">
                            <tr>
                                <th style="width: 20%">Nummer</th>
                                <th style="width: 80%">Name</th>
                            </tr>
                            <tr *ngFor="let outputproduct of getOutputProductsToShow() | ArtikelFilter:SearchStringOutProduct"
                                (click)="selectOutputProduct(outputproduct)">
                                <td>{{outputproduct.id}}</td>
                                <td>{{outputproduct.name}}</td>
                            </tr>
                        </table>
                    </cdk-virtual-scroll-viewport>
                    <button class="showButton" *ngIf="!showAllOutput" (click)="showAllOuputProducts()" mat-raised-button>
                        Alle anzeigen
                    </button>
                    <button class="showButton" *ngIf="showAllOutput" (click)="showAllOuputProducts()" mat-raised-button>
                        Top 10 anzeigen
                    </button>
                </div>

                <div class="rightTable" fxLayout="column" fxFlexAlign="stretch">
                    <h1 class="tableheader">Ausgewählt


                    </h1>
                    <cdk-virtual-scroll-viewport itemSize="10" class="viewportProducts" *ngIf="selectedOutputProducts">
                        <table class="productTable2">
                            <tr>
                                <th style="width: 20%">Nummer</th>
                                <th style="width: 80%">Name</th>
                            </tr>
                            <tr *ngFor="let outProd of selectedOutputProducts" (click)="unselectOutputProduct(outProd)">
                                <td>{{outProd.id}}</td>
                                <td>{{outProd.name}}</td>
                            </tr>
                        </table>
                    </cdk-virtual-scroll-viewport>
                </div>

            </div>

        </mat-tab>
        <ng-container *ngIf="typChosen !== 'Instandhaltung'; else maitenanceType">
            <mat-tab label="Metadaten" [disabled]="index !== 4">
                <div fxLayout="row" fxFlexAlign="stretch" class="mainLine">
                    <div fxLayout="row" fxFlexAlign="stretch">
                        <p class="viewHeader">Metadaten</p>
                        <button class="navigateButton" mat-raised-button (click)="go(-1)">Zurück</button>
                        <button class="navigateButton" (click)="confirmMetaData()"
                                *ngIf="ready && typChosen && !batchSize.invalid && !Durchsatz.invalid && !Vorrustzeit.invalid && !Nachrustzeit.invalid"
                                mat-raised-button>
                            Weiter
                        </button>

                    </div>
                    <button fxFlexAlign="end" class="navigateButton" (click)="cancelProcess()" mat-raised-button>
                        Abbrechen
                    </button>
                </div>
                <hr>
                <div class="metaDataWrapper">
                    <ng-container *ngIf="treatmentprocess">
                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input matInput [(ngModel)]="treatmentprocess.name" value="{{treatmentprocess.name}}">
                        </mat-form-field>
                    </ng-container>
                    <mat-form-field>
                        <mat-label>Minimale Chargengroße (t)</mat-label>
                        <div>
                            <input #batchSize="ngModel" appMinMaxValidator name="batchSize"
                                   (keyup)="onInputChangeBatchsize($event.target)" pattern="[0-9]*(\.?[0-9]{1,3}$)?" matInput
                                   [(ngModel)]="treatmentprocess.minbatchsize" value="{{treatmentprocess.minbatchsize}}"
                                   type="number" step="0.1" min="0.1">
                            <div *ngIf="batchSize.errors?.pattern " class="errorMessage">
                                Minimale Chargengroße darf nicht mehr als 3 Zahlen nach Komma haben.
                            </div>
                            <div *ngIf="batchSize.hasError('nullError')" class="errorMessage">
                                Chargengroße darf nicht Null sein.
                            </div>
                        </div>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Durchsatz (t/h)</mat-label>
                        <div>
                            <input #Durchsatz="ngModel" appMinMaxValidator max="999" (keyup)="onInputChange($event.target)"
                                   name="Durchsatz" pattern="^\d*(\.\d{0,3})?$" matInput
                                   [ngModel]="treatmentprocess.leadtimeperton| number: '1.0-3'"  (ngModelChange)="treatmentprocess.leadtimeperton=$event" value="{{treatmentprocess.leadtimeperton}}"
                                   type="number">
                            <div *ngIf="Durchsatz.errors?.pattern" class="errorMessage">
                                Durchsatz darf nicht mehr als 3 Zahlen nach Komma haben.
                            </div>
                            <div *ngIf="Durchsatz?.hasError('nullError')" class="errorMessage">
                                Durchsatz darf nicht Null sein.
                            </div>
                        </div>
                    </mat-form-field>
                    <mat-form-field hideRequiredMarker>
                        <mat-label>Vorrüstzeit (h)</mat-label>
                        <div>
                            <input #Vorrustzeit="ngModel" required name="Vorrustzeit"
                                   (keyup)="onInputChangeTimeBefore($event.target)" pattern="^\d*(\.\d{0,2})?$" matInput
                                   [(ngModel)]="treatmentprocess.setuptimebefore" value="{{treatmentprocess.setuptimebefore}}"
                                   type="number">
                            <div *ngIf="Vorrustzeit.errors?.pattern " class="errorMessage">
                                Vorrüstzeit darf nicht mehr als 2 Zahlen nach Komma haben.
                            </div>
                            <div *ngIf="Vorrustzeit.errors?.required " class="errorMessage">
                                Vorrüstzeit darf nicht leer sein.
                            </div>
                        </div>
                    </mat-form-field>
                    <mat-form-field hideRequiredMarker>
                        <mat-label>Nachrüstzeit (h)</mat-label>
                        <div>
                            <input #Nachrustzeit="ngModel" required name="Nachrustzeit"
                                   (keyup)="onInputChangeTimeAfter($event.target)" pattern="^\d*(\.\d{0,2})?$" matInput
                                   [(ngModel)]="treatmentprocess.setuptimeafter" value="{{treatmentprocess.setuptimeafter}}"
                                   type="number">
                            <div *ngIf="Nachrustzeit.errors?.pattern " class="errorMessage">
                                Nachrüstzeit darf nicht mehr als 2 Zahlen nach Komma haben.
                            </div>
                            <div *ngIf="Nachrustzeit.errors?.required " class="errorMessage">
                                Nachrüstzeit darf nicht leer sein.
                            </div>
                        </div>
                    </mat-form-field>
                    <mat-form-field class="commentarWrap" >
                        <mat-label>Kommentar</mat-label>
                        <textarea class="commentArea" maxlength="501" matInput [(ngModel)]="commentText" value="{{commentText}}"></textarea>
                        <ng-container *ngIf="commentText">
                            <div *ngIf="commentText.length > 500" class="errorMessage">
                                Maximal 500 Zeichen erlaubt.
                            </div>
                        </ng-container>
                    </mat-form-field>
                </div>
            </mat-tab>
        </ng-container>
        <ng-template #maitenanceType>
            <mat-tab label="Metadaten" [disabled]="index !== 4">
                <div fxLayout="row" fxFlexAlign="stretch" class="mainLine">
                    <div fxLayout="row" fxFlexAlign="stretch">
                        <p class="viewHeader">Metadaten</p>
                        <button class="navigateButton" mat-raised-button (click)="goBackToRessourceChoice()">Zurück</button>
                        <button class="navigateButton" (click)="confirmMetaData()"
                                *ngIf="ready && typChosen"
                                mat-raised-button>
                            Weiter
                        </button>

                    </div>
                    <button fxFlexAlign="end" class="navigateButton" (click)="cancelProcess()" mat-raised-button>
                        Abbrechen
                    </button>
                </div>
                <hr>
                <div class="metaDataWrapper">
                    <ng-container *ngIf="treatmentprocess">
                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input matInput [(ngModel)]="treatmentprocess.name" value="{{treatmentprocess.name}}">
                        </mat-form-field>
                    </ng-container>
                    <mat-form-field class="commentarWrap" >
                        <mat-label>Kommentar</mat-label>
                        <textarea class="commentArea" maxlength="501" matInput [(ngModel)]="commentText" value="{{commentText}}"></textarea>
                        <ng-container *ngIf="commentText">
                            <div *ngIf="commentText.length > 500" class="errorMessage">
                                Maximal 500 Zeichen erlaubt.
                            </div>
                        </ng-container>
                    </mat-form-field>
                </div>
            </mat-tab>
        </ng-template>

        <mat-tab label="Zusammenfassung" [disabled]="index !== 5">
            <div fxLayout="row" fxFlexAlign="stretch" class="mainLine">
                <div fxLayout="row" fxFlexAlign="stretch">
                    <p class="viewHeader">Zusammenfassung</p>
                    <button class="navigateButton" mat-raised-button (click)="backToMetaData()">Zurück</button>
                    <button class="navigateButton" (click)="saveProcess()" mat-raised-button>
                        Speichern
                    </button>
                    <button fxFlexAlign="end" class="navigateButton" (click)="cancelProcess()" mat-raised-button>
                        Abbrechen
                    </button>
                </div>
            </div>
            <hr>

            <ng-container *ngIf="typChosen !== 'Instandhaltung'; else maitenanceTypeSummary">
                <div class="chargeCard">
                    <div fxLayout="column" *ngIf="index===5">
                        <div fxLayout="row" class="EntryRow">
                            <p class="conHeader">Prozessname</p>
                            <p class="conTxt">{{treatmentprocess.name}}</p>
                        </div>
                        <div fxLayout="row" class="EntryRow">
                            <p class="conHeader">Minimale Chargengröße (t)</p>
                            <p class="conTxt">{{treatmentprocess.minbatchsize | number: '1.0-3':'de'}} Tonne(n)</p>
                        </div>
                        <div fxLayout="row" class="EntryRow">
                            <p class="conHeader">Durchsatz (t/h)</p>
                            <p class="conTxt">{{treatmentprocess.leadtimeperton | number: '1.0-3':'de'}} Tonne(n) pro Stunde</p>
                        </div>
                        <div fxLayout="row" class="EntryRow">
                            <p class="conHeader">Vorrüstzeit (h)</p>
                            <p class="conTxt">{{treatmentprocess.setuptimebefore | number: '1.0-3':'de'}} Stunde(n)</p>
                        </div>
                        <div fxLayout="row" class="EntryRow">
                            <p class="conHeader">Nachrüstzeit (h)</p>
                            <p class="conTxt">{{treatmentprocess.setuptimeafter | number: '1.0-3':'de'}} Stunde(n)</p>
                        </div>

                    </div>
                    <div class="processentry" fxLayout="column" *ngIf="index===5">
                        <div class="flexRow">
                            <div class="elementrow" fxLayout="column">
                                <p class="header">Input</p>
                                <div class="outputmaterialentry">
                                    <p class="outmaterial">{{selectedInputProduct.id}} {{selectedInputProduct.name}}</p>
                                </div>
                                <p class="header">Ressourcentypen</p>
                                <div class="ressourcesentry" *ngFor="let ressour of selectedRessources">
                                    <p class="resour">{{ressour.quantity}}x {{ressour.name}}</p>
                                </div>

                            </div>
                            <div class="flexIcon">
                                <mat-icon class="iconArrow">chevron_right</mat-icon>
                            </div>

                            <div class="addinfo flexResources">
                                <p class="addHeader">Output</p>
                                <div class="outputmaterialentry" *ngFor="let outmat of selectedOutputProducts">
                                    <p class="outmaterial">{{outmat.id}} {{outmat.name}}</p>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="commentEntry" fxLayout="column" *ngIf="index===5 && commentText">
                        <p class="header">Kommentar</p>
                        <p style="word-wrap: break-word;">
                            {{commentText}}
                        </p>
                    </div>
                </div>
            </ng-container>
            <ng-template #maitenanceTypeSummary>
                <div class="ChargeCard">
                    <div fxLayout="column" *ngIf="index===5">
                        <div fxLayout="row" class="EntryRow">
                            <p class="conHeader">Prozessname</p>
                            <p class="conTxt">{{treatmentprocess.name}}</p>
                        </div>

                    </div>
                    <div class="processentry" fxLayout="column" *ngIf="selectedRessources.length > 0; else noResources">
                        <p class="header">Ressourcentypen</p>
                        <div class="ressourcesentry" *ngFor="let ressour of selectedRessources">
                            <p class="resour">{{ressour.quantity}}x {{ressour.name}}</p>
                        </div>
                    </div>
                    <ng-template #noResources>
                        <div fxLayout="row" class="EntryRow">
                            <p class="conHeader">Ressourcentypen</p>
                            <p class="conTxt">-</p>
                        </div>
                    </ng-template>
                    <div class="commentEntry" fxLayout="column" *ngIf="index===5 && commentText">
                        <p class="header">Kommentar</p>
                        <p style="word-wrap: break-word;">
                            {{commentText}}
                        </p>
                    </div>
                </div>
            </ng-template>

        </mat-tab>
    </mat-tab-group>

</div>

